import { defineMessages } from 'react-intl';

export default defineMessages({
    baDriverAssignmentTitle: {
        id: 'endorsement.ba.views.ba-driver-assignment-details.Driver Assignment',
        defaultMessage: 'Driver Assignment',
    }
});
